import { jsx as _jsx } from "react/jsx-runtime";
import { BottomNavButton } from './bnav-btn';
import style from './style.module.scss';
export default function BottomBar({ items, activeKey, onSelect }) {
    return (_jsx("nav", { className: style['bottom-nav'], children: items.map((item) => (
        // <button
        //   key={item.key}
        //   className={[style['bottom-nav-btn'], item.key === activeKey ? style['active'] : '']
        //     .filter(Boolean)
        //     .join(' ')}
        //   onClick={() => onSelect(item.key)}
        // >
        //   <span>{item.icon}</span>
        //   <span>{item.label}</span>
        // </button>
        _jsx(BottomNavButton, { isActive: item.key === activeKey, navIcon: item.icon, label: item.label, onClick: () => onSelect(item.key) }))) }));
}
